export const HEADER_MARGIN_TOP_PX = 4;
